import { Typography } from '@mui/material'

const HelpText = () => <div className='p-5'>
  <Typography variant='h4'>Duplicate template</Typography>
  <p>Duplicate an active template when you want to reuse its design, variables and settings. Give the copy a distinct name, then continue editing it independently.</p>
  <Typography variant='h5'>After duplication</Typography>
  <p>The new template becomes the current template and opens directly in the editor. Existing passes remain associated with the source template; duplication never copies issued passes.</p>
</div>

export default HelpText
